"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class CoverageDisplayOption {
    constructor(id, type, items, name, icon, color) {
        this.id = id;
        this.type = type;
        this.items = items;
        this.name = name;
        this.icon = icon;
        this.color = color;
    }
    static fromObj(data) {
        const items = data.items.map((item) => {
            if (item.value && item.text) {
                return item;
            }
            if (item.limitRange && item.step) {
                return item;
            }
            return item;
        });
        return new CoverageDisplayOption(data.id, data.type, items, data.name, data.icon, data.color);
    }
}
exports.default = CoverageDisplayOption;
//# sourceMappingURL=coverageDisplayOption.class.js.map